<template>
  <div id="submenu">
    <router-link :to="{ name: 'AccountOverview' }" class="list-group-item" :class="{active: menu_list.overview}">Account Overview</router-link>
    <router-link v-if="is_customer" :to="{ name: 'ShipmentTracking' }" class="list-group-item" :class="{active: menu_list.shipping||menu_list.po}">Order Status</router-link>
    <!-- <router-link v-if="is_customer" :to="{ name: 'QuoteRequest' }" class="list-group-item" :class="{active: menu_list.quote || menu_list.quoteDetails}">Quote Request</router-link> -->
    <router-link :to="{ name: 'ChangePassword' }" class="list-group-item" :class="{active: menu_list.password}">Change Password</router-link>
    <router-link v-if="is_customer" :to="{ name: 'Newsletter' }" class="list-group-item" :class="{active: menu_list.newsletter}">Email Newsletter</router-link>
    <router-link v-if="is_customer" :to="{ name: 'Datafeed' }" class="list-group-item" :class="{active: menu_list.datafeed}">Data Feed Service</router-link>
    <router-link v-if="is_customer" :to="{ name: 'WebService' }" class="list-group-item" :class="{active: menu_list.api}">Web Service API</router-link>
    <router-link v-if="is_customer && has_pricelist" :to="{ name: 'EdiPrices' }" class="list-group-item" :class="{active: menu_list.edi}">{{ custno }} Price List</router-link>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useStore } from "vuex"

export default {
  props: [ 'menu' ],
  setup(props) {
    const store = useStore()
    const is_customer = ref(store.getters.isCustomer)
    const has_pricelist = ref(store.getters.edi_pricelist)
    const is_rma = ref(store.getters.isRMA)
    const custno = ref(store.getters.custno)

    const menu_list = ref({
        overview: false,
        shipping: false,
        po: false,
        password: false,
        newsletter: false,
        datafeed: false,
        api: false,
        webDetails:false,
        quote: false,
        quoteDetails: false,
        edi: false
      })
      
    menu_list.value[props.menu] = true
    if (props.menu === 'webDetails'){
      menu_list.value['po'] = true
    }
     
    return { menu_list, is_customer,has_pricelist, is_rma, custno }
  }
}
</script>



